/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.GiftCardBalance {
    angular.module("meevo.plugins.giftCardBalance", []);
}